import React from 'react';
import { completeStartup } from '../utils/startup';
import NotFound from './NotFound';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    completeStartup();
    // 你同样可以将错误日志上报给服务器
    console.error("Uncaught error:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <NotFound kind={this.state.error?.name === 'ChunkLoadError' ? 'network' : 'server'} onRetry={() => window.location.reload()} />
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
